import { ICellRendererParams } from "ag-grid-community";
import { FC, useState } from "react";
import SiteURLsDialog from "components/portfolio/components/SiteURLsDialog";
import { Site } from "types/portfolio";
import dynamic from "next/dynamic";
import useFilterModelHighlightHTML from "components/app/useFilterModelHighlightHTML";
import { AxiosInstance } from "axios";
import { classHOC } from "components/app/ClassWrapper";

const SiteURLsRenderer: FC<
  ICellRendererParams & {
    type?: string;
    axios?: AxiosInstance;
    subType?: string;
  }
> = ({ api, data, type = "default", axios, subType }) => {
  const [siteDialogStatus, setSiteDialogStatus] = useState(false);
  const [siteCellData, setSiteCellData] = useState<Site[]>([]);
  const value = data?.sites;
  const siteURLsDialogHandleClose = () => {
    setSiteDialogStatus(false);
    setSiteCellData([]);
  };

  const siteURLsDialogHandleOpen = (value: Site[]) => () => {
    setSiteDialogStatus(true);
    setSiteCellData(value.filter((v: Site) => v.siteKey));
  };
  // only show the have site length
  const siteHasVal = value?.filter((v: Site) => v.siteName);

  return (
    <div>
      {siteHasVal?.length ? (
        siteHasVal?.length === 1 ? (
          <span
            dangerouslySetInnerHTML={{
              __html: useFilterModelHighlightHTML(api, `${value[0].siteName}`),
            }}
          />
        ) : (
          <>
            <div
              onClick={siteURLsDialogHandleOpen(value)}
              style={{ cursor: "pointer", color: "dodgerblue" }}
              dangerouslySetInnerHTML={{
                __html: useFilterModelHighlightHTML(api, `Show All (${siteHasVal?.length})`),
              }}
            />
            <SiteURLsDialog
              siteDialogStatus={siteDialogStatus}
              siteURLsHandleClose={siteURLsDialogHandleClose}
              siteCellData={siteCellData}
              type={type}
              axios={axios}
              accountType={data.accountType}
              subType={subType}
            />
          </>
        )
      ) : value ? (
        <span
          dangerouslySetInnerHTML={{
            __html: useFilterModelHighlightHTML(api, "N/A"),
          }}
        />
      ) : null}
    </div>
  );
};

export default dynamic(() => Promise.resolve(classHOC(SiteURLsRenderer)), {
  ssr: false,
});
